import React from "react";
import Container from "@mui/material/Container";
import { Box, Grid, Typography } from "@mui/material";
import { translations } from "../translations";

const About = ({ siteLanguage }) => {
  return (
    <Container maxWidth="md">
      <Box>
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12}>
            <Typography
              align="center"
              variant="h4"
              sx={{
                marginTop: {
                  xs: "1em", // increases marginTop on xs screens
                  sm: "0", // reset marginTop on sm screens and above
                },
              }}
            >
              {translations[siteLanguage].aboutPageTitle}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={8}>
            <Typography
              align="justify"
              sx={{
                marginBottom: {
                  xs: "1em", // increases marginTop on xs screens
                  sm: "0", // reset marginTop on sm screens and above
                },
              }}
            >
              {translations[siteLanguage].aboutPageDescription}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default About;
